/* Copyright (c) 2024, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
export enum TimeUnit {
    HOURS = 'hours',
    MINUTES = 'minutes',
    SECONDS = 'seconds',
    MILLISECONDS = 'milliseconds',
    DAYS = 'days',
    WEEKS = 'weeks',
    MONTHS = 'months',
    YEARS = 'years'
}

export enum DateGranulity {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year'
}

export const hourToSeconds = 3600;
export const minuteToSeconds = 60;
export const oneDayInSeconds = 86400;
